import { EntityWidget } from "./EntityWidget";
import { CommentEntityController } from "../CommentEntityController";
import { Comment } from "@rhinov/savane-js";

export class CommentEntityWidget extends EntityWidget{

    declare controller: CommentEntityController;
    declare entity: Comment;

    addCommentImage = () => {
        this.removeimagesListener();
        this.controller.addCommentImage();
        let list = document.getElementById('commentImageList');
        if (list) {
            list.innerHTML = this.handleImageList();
            this.setimagesListener();
        }
    }

    removeCommentImage = (event: Event) => {
        this.removeimagesListener();
        this.controller.removeCommentImage((event.currentTarget as HTMLInputElement & { param?: string }).param!);
        let list = document.getElementById('commentImageList');
        if (list) {
            list.innerHTML = this.handleImageList();
            this.setimagesListener();
        }
    }

    changeURL = (event: Event) => {
        (this.entity as any).image = (event.currentTarget as HTMLInputElement).value;
    }

    changeComment = (event: Event) => {
        var elem = event.currentTarget as HTMLInputElement & { param?: string };
        (this.entity as any)[elem.param!] = elem.value;
        this.controller.setPropertiesValues(elem.param!, (this.entity as any)[elem.param!], 1);
    }

    constructor(entity: Comment, panel: any) {
        super(entity, panel, null);
        this.controller = new CommentEntityController(entity, panel);
        this.propertiesTab = ['text', 'images'];
        this.controller.propertiesTab = this.propertiesTab;
    }

    text(property: any): string {
        return `
            <!--text -->
            <div class="property-item padding">
                <div style="display:inline-flex">
                    <textarea id="text-${property.key}" cols="80" rows="5"
                        style="max-width:500px;max-height:350px"></textarea>
                </div>
            </div>
        `;
    }

    handleImageList(): string {
        var html = "";
        var index = 0;
        this.entity.images.forEach(item => {
            html += `
                <div style="position: relative;margin-bottom:8px">
                    <div id="removeCommentImage-${index}" style="position: absolute; top: 4px; right: 4px; z-index: 1;">
                        <i class="fas fa-2x fa-trash-alt" style="color: rgb(46, 46, 46); text-shadow:1px 1px rgba(255,255,255,.75)"></i>
                    </div>
                    <a target="_blank" href="${item}">
                        <img width="500px" src="${item}">
                    </a>
                </div>
            `;
            index++;
        });
        return html;
    }

    images(): string {
        return `
            <!-- images -->
            <div class="property-item padding">
                <div>
                    <input id="imageURL" style="min-width : 500px" type="text" placeholder="URL de l'image">

                </div>
                <div style="text-align: center; margin-top: 8px; margin-bottom: 8px;">
                    <button id="addImage" type="button" class="btn btn-flat btn-success borderless">Ajouter</button>
                </div>
                <div id="commentImageList" style="overflow: auto; height: 450px; padding-right: 10px">
                    ${this.handleImageList()}
                </div>
            </div>
        `;
    }

    html(): string {
        var i;
        var html = this.nameHeader() + this.propertyStart();
        for (i = 0; i < this.propertiesTab.length; i++) {
            html += (this as any)[this.propertiesTab[i]](this.panel.properties[i]);
        }

        return html + this.propertyEnd();
    }

    settextListener(property: any) {
        let element = document.getElementById(`text-${property.key}`) as HTMLInputElement & { param?: string };
        if (element){
            element.value = (this.entity as any)[property.key] ? (this.entity as any)[property.key] : "";
            element.param = property.key;
            element.addEventListener('change', this.changeComment.bind(this));
        }
    }

    removetextListener(property: any) {
        let element = document.getElementById(`text-${property.key}`);
        if (element){
            element.removeEventListener('change', this.changeComment);
        }
    }

    setimagesListener() {
        let url = document.getElementById('imageURL') as HTMLInputElement;
        if (url) {
            url.value = (this.entity as any).image ? (this.entity as any).image : "";
            url.addEventListener('change', this.changeURL)
        }
        let addImage = document.getElementById('addImage');
        if (addImage) {
            addImage.addEventListener('click', this.addCommentImage);
        }
        var index = 0;
        this.entity.images.forEach(image => {
            let img = document.getElementById(`removeCommentImage-${index}`) as HTMLInputElement & { param?: string };
            if (img) {
                img.param = image;
                img.addEventListener('click', this.removeCommentImage);
            }
            index++;
        })
    }

    removeimagesListener() {
        let url = document.getElementById('imageURL');
        if (url) {
            url.removeEventListener('change', this.changeURL);
        }
        let addImage = document.getElementById('addImage');
        if (addImage) {
            addImage.removeEventListener('click', this.addCommentImage);
        }
        var index = 0;
        this.entity.images.forEach(image => {
            let img = document.getElementById(`removeCommentImage-${index}`);
            if (img) {
                img.removeEventListener('click', this.removeCommentImage);
            }
            index++;
        })
    }
}